import React, { useEffect, useRef } from 'react';
import './footer.css';
import * as THREE from "three";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaLocationDot,
  FaPhone,
  FaEnvelope
} from "react-icons/fa6";
import { Link } from 'react-router-dom';
import logo from '../assets/images/Fundswalle_Logo.png';

const Footer = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    let scene = new THREE.Scene();
    let camera = new THREE.PerspectiveCamera(75, window.innerWidth / 400, 0.1, 1000);
    let renderer = new THREE.WebGLRenderer({ alpha: true });

    renderer.setSize(window.innerWidth, 400);
    canvasRef.current.appendChild(renderer.domElement);

    const particleCount = 800;
    const positions = [];
    const colors = [];

    for (let i = 0; i < particleCount; i++) {
      positions.push((Math.random() - 0.5) * 20); 
      positions.push((Math.random() - 0.5) * 20); 
      positions.push((Math.random() - 0.5) * 20); 

      colors.push(1, 0.95, 0.45); 
    }

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
    geometry.setAttribute("color", new THREE.Float32BufferAttribute(colors, 3));

    const material = new THREE.PointsMaterial({
      size: 0.08,
      vertexColors: true,
      transparent: true,
      opacity: 0.9
    });

    const particles = new THREE.Points(geometry, material);
    scene.add(particles);

    camera.position.z = 6;

    function animate() {
      requestAnimationFrame(animate);
      particles.rotation.y += 0.0008;
      particles.rotation.x += 0.0004;
      renderer.render(scene, camera);
    }
    animate();

    return () => {
      renderer.dispose();
    };
  }, []);

  // ⭐ Updated Social Links (YouTube Added)
  const socialLinks = [
    {
      icon: FaFacebookF,
      href: "https://www.facebook.com/people/Fundswalle/61583318571614/?rdid=ObclDGJysz99TNgu&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CqKuGMa65%2F"
    },
    { icon: FaLinkedinIn, href: "https://www.linkedin.com/company/fundswalle/?viewAsMember=true" },
    {
      icon: FaInstagram,
      href: "https://www.instagram.com/fundswalle/?igsh=MTZlemN5Y3JxbXNjdw%3D%3D#"
    },
    { icon: FaYoutube, href: "https://www.youtube.com/@fundswalle" }, // ⭐ YouTube Added
  ];

  return (
    <footer className="footer-section premium-gradient-theme">

      <div className="footer-canvas" ref={canvasRef}></div>

      <div className="container footer-container">
        <div className="footer-columns">

          <div className="footer-column footer-logo-column brand-info-box">
            <img src={logo} alt="Fundswalle Logo" className="footer-logo" />
            <p className="footer-text">
              <strong style={{ color: '#FFD700' }}>Marathon Finlease Private Limited -</strong>
              Empowering India’s Workforce with Smarter, Faster Lending Solutions. <br />
              We deliver timely, trusted, and technology-driven credit solutions.
            </p>

            <div className="footer-social">
              {socialLinks.map((item, index) => (
                <a key={index} href={item.href} target="_blank" rel="noopener noreferrer">
                  <item.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              {[
                ['Apply Loan', 'apply-now'],
                ['Contact Us', 'contact-us'],
                ['Corporate Governance', 'corporate-governance'],
                ['Interest Rate Policy', 'interest-rate-policy'],
                ['Risk Management Policy', 'risk-management-policy'],
              ].map(([label, path], index) => (
                <li key={index}>
                  <Link to={`/${path}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Pages */}
          <div className="footer-column">
            <h4>Legal Pages</h4>
            <ul>
              {[
                ['Terms and Conditions', 'terms-conditions'],
                ['Privacy Policy', 'privacy-policy'],
                ['Fair Practice Code', 'fair-practice-code'],
                ['FAQs', 'faqs'],
              ].map(([label, path], index) => (
                <li key={index}>
                  <Link to={`/${path}`}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4>Get In Touch</h4>
            <div className="footer-contact">
              <p><FaLocationDot className="icon" /> Registered Office: Office no. 304, Laxman Palace, Delhi</p>
              <p><FaEnvelope className="icon" /> <a href="mailto:info@fundswalle.com">info@fundswalle.com</a></p>
              <p><FaPhone className="icon" /> <a href="tel:+918800846929">+91-8800846929</a></p>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} Marathon Finlease Private Limited. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
